import { mapGetters } from 'vuex';
import enJSON from '@/common/utilities/lang/en/privacypolicy.js';
import esJSON from '@/common/utilities/lang/es/privacypolicy.js';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'privacyPolicy',
    inject: ['$eventBus'],
    components: {
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    methods: {
        getContent(value) {
            return this.molang(value);
        },
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'privacypolicy', en: enJSON, es: esJSON });
    },
};
